// Application constants
export const APP_CONFIG = {
  name: 'Eventi',
  version: '1.0.0',
  colors: {
    primary: '#67314f',
    primaryHover: '#5a2a42',
    secondary: '#f4dbc5',
    text: '#181818',
    textSecondary: '#93989c',
    background: '#ffffff',
    backgroundSecondary: '#f6f8f8',
    border: '#f1f4f4',
    success: '#426a53',
    error: '#925b64',
    warning: '#c5cbd3',
  },
  fonts: {
    primary: '"Inter", sans-serif',
    secondary: '"HT Mosafer Rounded", sans-serif',
  },
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  }
};

export const ROUTES = {
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  COMPANY_PROFILE: '/company-profile',
  ORDERS: '/orders',
  PRODUCTS: '/products',
  SERVICES: '/services',
  REVIEWS: '/reviews',
  QUESTIONS: '/questions',
  NOTIFICATIONS: '/notifications',
  SETTINGS: '/settings',
  TRANSACTIONS: '/transactions',
  BECOME_VENDOR: '/become-vendor',
  ONBOARDING: {
    STEP1: '/onboarding/step1',
    STEP2: '/onboarding/step2',
    STEP3: '/onboarding/step3',
    STEP4: '/onboarding/step4',
  }
};

export const ORDER_STATUS = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  IN_PROGRESS: 'In progress',
  DELIVERING: 'Delivering',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  CHANGES: 'Changes',
} as const;

export const PRODUCT_STATUS = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  UNDER_REVIEW: 'under_review',
  DRAFT: 'draft',
} as const;

export const TRANSACTION_TYPES = {
  PAYMENT: 'payment',
  REFUND: 'refund',
  WITHDRAWAL: 'withdrawal',
  FEE: 'fee',
} as const;

export const TRANSACTION_STATUS = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  FAILED: 'failed',
} as const;
